
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import SettlementPrint from "./settlement-print.vue";
import ShangHaiPrint from "./shanghai-print.vue";
import DelegatePrint from "./delegate-print.vue";
import MissPrint from "./miss-print.vue";
import { checkMoney, isPositiveIntegerZero, partsQuantityRules } from "@common/src/utils/verify";

import t from "@common/src/i18n/t";

const store = namespace("store");
const finance = namespace("finance");
const service = namespace("service");
const app = namespace("app");

@Component({
  components: { SettlementPrint, ShangHaiPrint, DelegatePrint, MissPrint }
})
export default class PrintDropdown extends Vue {
  @store.State storeData;
  @finance.Action getReceiptDetail;
  @service.Action getOrderDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @Prop({ type: Object, default: () => {} })
  detailData: any;
  @Prop({ type: String, default: "button" }) // button text
  triggerStyleType: string;
  showPreviewPrint = false; // 结算单预览
  showMissPreviewPrint = false; // 避单结算单预览
  showDelegatePrint = false;
  showMissPrint = false;
  getData = false;
  showShangHaiPrint = false;
  handleCopyMenuClick(command) {
    if (command === "print") {
      this.detailData.storeData = this.storeData;
      if (!this.detailData.receiptNo) {
        return this.$message.error(t("other.tamll-order-print-tips") as string);
      }
      this.queryAllOrderByReceipt().then(() => {
        this.showPreviewPrint = true;
      });
    } else if (command === "delegate") {
      this.detailData.storeData = this.storeData;
      this.showDelegatePrint = true;
    } else if (command === "miss") {
      if (!this.detailData.receiptNo) {
        return this.$message.error(t("other.tamll-order-print-tips") as string);
      }
      this.showMissPrint = true;
      this.getData = true;
    } else if (command === "shanghai") {
      this.showShangHaiPrint = true;
    }
  }
  queryAllOrderByReceipt() {
    const service = [];
    const parts = [];
    const additional = [];
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return this.getReceiptDetail({
      receiptNo: this.detailData.receiptNo,
      pageSize: 999,
      pageNum: 1
    }).then(
      async receiptData => {
        const orderList = receiptData.data.orderList || [];
        for (let i = 0; i < orderList.length; i++) {
          await this.getOrderDetail({
            orderNo: orderList[i].orderNo
          }).then(data => {
            if (data.data.serviceDetail && data.data.serviceDetail.length > 0) {
              service.push(...data.data.serviceDetail);
            }
            if (data.data.partsDetail && data.data.partsDetail.length > 0) {
              parts.push(...data.data.partsDetail);
            }
            if (data.data.additionalFees) {
              additional.push({
                additionalFees: data.data.additionalFees,
                additionalFeesRemark: data.data.additionalFeesRemark
              });
            }
          });
        }
        loading.close();
        this.detailData.allOrderDetail = { service, parts, additional, receiptData: receiptData.data };
        console.log(service, parts, additional);
      },
      () => {
        loading.close();
      }
    );
  }
  settlementPrintObj: any = {
    id: "printMer1",
    popTitle: t("service.final-statement"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  shanghaiPrintObj: any = {
    id: "printMer3",
    popTitle: t("v210831.shanghai-motor-vehicle-settlement"),
    extraCss: "",
    extraHead: ""
  };
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  missDetailData: any = {};
  handleMissPrintFlag() {
    let ref = this.$refs.missPrint as any;
    this.missDetailData = ref.orderFormData;
    console.log(this.missDetailData);
    if (this.checkAddData()) {
      this.showMissPrint = false;
      ref.init();
      this.missDetailData.storeData = this.storeData;
      if (!this.detailData.receiptNo) {
        return this.$message.error(t("other.tamll-order-print-tips") as string);
      }
      this.queryAllOrderDipatch().then(() => {
        this.showMissPreviewPrint = true;
      });
    }
  }
  checkAddData(): boolean {
    for (let i = 0; i < this.missDetailData.serviceDetail.length; i++) {
      if (!this.missDetailData.serviceDetail[i].serviceCode) {
        this.$message.warning(t("v210801.pls-select-project"));
        return false;
      }
      if (!this.missDetailData.serviceDetail[i].technicianCode.length) {
        this.$message.warning(t("v210831.please-select-a"));
        return false;
      }
      if (!this.missDetailData.serviceDetail[i].amount) {
        this.$message.warning(t("v210831.please-enter-the-work-group-fee"));
        return false;
      }
      if (!checkMoney(this.missDetailData.serviceDetail[i].amount).success) {
        this.$message.warning(t("v210831.please-enter-correct-worker-fee"));
        return false;
      }
      if (!isPositiveIntegerZero(this.missDetailData.serviceDetail[i].workingHours)) {
        this.$message.warning(t("v210831.please-enter-positive-integer-or-zero"));
        return false;
      }
    }
    for (let i = 0; i < this.missDetailData.partsDetail.length; i++) {
      if (!this.missDetailData.partsDetail[i].partsCode) {
        this.$message.warning(t("setting.select-spare-parts"));
        return false;
      }
      if (!this.missDetailData.partsDetail[i].sellingPrice) {
        this.$message.warning(t("v210831.please-enter-unit"));
        return false;
      }
      if (!checkMoney(this.missDetailData.partsDetail[i].sellingPrice).success) {
        this.$message.warning(t("v210831.please-enter-positive-integer-or-float"));
        return false;
      }
      if (!this.missDetailData.partsDetail[i].quantity) {
        this.$message.warning(t("v210831.please-enter-quantity"));
        return false;
      }
      if (!partsQuantityRules(this.missDetailData.partsDetail[i].quantity)) {
        this.$message.warning(t("v210831.please-input-the"));
        return false;
      }
    }
    return true;
  }
  queryAllOrderDipatch() {
    const service = [];
    const parts = [];
    const additional = [];
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return this.getReceiptDetail({
      receiptNo: this.missDetailData.receiptNo,
      pageSize: 999,
      pageNum: 1
    }).then(
      async () => {
        this.missDetailData.serviceDetail.forEach(item => {
          item.technicianArray = item.technicianCode.map(item => {
            return {
              ...item,
              technicianCode: item.userCode || item.technicianCode,
              technicianName: item.staffName || item.technicianName
            };
          });
        });
        service.push(...this.missDetailData.serviceDetail);
        parts.push(...this.missDetailData.partsDetail);
        additional.push({
          additionalFees: this.missDetailData.additionalFees,
          additionalFeesRemark: this.missDetailData.additionalFeesRemark
        });
        loading.close();
        if (this.missDetailData.paymentList.length) {
          // 把避单金额加到第一个支付方式上
          this.missDetailData.paymentList[0].paidAmount = this.missDetailData.receiptAmount;
          this.missDetailData.paymentList = [this.missDetailData.paymentList[0]];
        } else {
          // 没有支付方式，默认方法
          this.missDetailData.paymentList = [
            {
              paidAmount: this.missDetailData.receiptAmount,
              paidMethod: "3",
              paidMethodDesc: t("service.wechat-pay")
            }
          ];
        }
        this.missDetailData = {
          ...this.missDetailData,
          // allOrderDetail: { service, parts, additional, receiptData: receiptData.data }
          allOrderDetail: { service, parts, additional, receiptData: this.missDetailData }
        };
      },
      () => {
        loading.close();
      }
    );
  }
}
